var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.right",value:(_vm.isIconOnly ? _vm.text : ''),expression:"isIconOnly ? text : ''",modifiers:{"right":true}}],class:[
    'application-chrome-nav-item super-sidebar-nav-item !gl-mx-3 !-gl-mt-2 !gl-mb-2 !gl-justify-start !gl-px-2-5 !gl-py-2',
    { 'gl-gap-3': !_vm.isIconOnly },
  ],attrs:{"button-text-classes":_vm.isIconOnly ? 'gl-hidden' : null,"icon":_vm.icon,"aria-label":_vm.text,"category":"tertiary","data-testid":"super-sidebar-collapse-button"},on:{"click":_vm.emitToggle}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }